module.exports = __webpack_public_path__ + "img/profile-ebadge.c54edad0.png";